/* Adventskalender PLUS XXL – Kalender-Seite (Section sp-adv-kalender).
   Türchen n öffnet am n-ten Werktag (Mo–Fr) ab Start um 0:00 Uhr deutscher Zeit und gilt 7 Tage lang
   (bis zum 6. Folgetag 23:59 Uhr, Entscheidung 01.11.2026). Test: ?sptag=JJJJ-MM-TT simuliert diesen Tag um 10:00 Uhr. */
(function () {
  var el = document.querySelector('[data-spak]');
  if (!el || el.dataset.ready) return;
  el.dataset.ready = '1';
  var EN = el.dataset.lang === 'en';
  var START = el.dataset.start || '2026-11-02';
  var COUNT = parseInt(el.dataset.count, 10) || 29;
  var DAY = 864e5, HOUR = 36e5;
  function $(s) { return el.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function parse(s) { var p = String(s).split('-'); return Date.UTC(+p[0], p[1] - 1, +p[2]); }
  function iso(t) { return new Date(t).toISOString().slice(0, 10); }
  function wdOf(t) { return new Date(t).getUTCDay(); }
  /* Berlin: im Kalenderzeitraum (Nov/Dez) gilt MEZ = UTC+1 */
  function berlinEpoch(dayT) { return dayT - HOUR; }

  var WD = EN ? ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] : ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function dShort(t) { var d = new Date(t); return EN ? d.getUTCDate() + ' ' + MON[d.getUTCMonth()] : ('0' + d.getUTCDate()).slice(-2) + '.' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '.'; }
  function dLong(t) { return WD[wdOf(t)] + ' ' + dShort(t); }

  /* Fahrplan */
  var doors = [], t = parse(START);
  while (doors.length < COUNT) {
    var wd = wdOf(t);
    if (wd >= 1 && wd <= 5) doors.push({ n: doors.length + 1, open: t, close: t + 6 * DAY, fri: wd === 5 });
    t += DAY;
  }

  /* Heute */
  var params = new URLSearchParams(location.search);
  var sim = params.get('sptag');
  if (sim && !/^\d{4}-\d{2}-\d{2}$/.test(sim)) sim = null;
  var realDay;
  try { realDay = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Berlin' }).format(new Date()); } catch (e) { realDay = iso(Date.now()); }
  var design = !!(window.Shopify && window.Shopify.designMode);
  if (!sim && design && parse(realDay) < doors[0].open) sim = START;
  var test = !!sim;
  function nowMs() { return sim ? berlinEpoch(parse(sim)) + 10 * HOUR : Date.now(); }
  var today = parse(sim || realDay);

  function state(d) {
    if (today < d.open) return 'future';
    if (today > d.close) return 'past';
    if (today === d.open) return 'new';
    if (today === d.close) return 'last';
    return 'open';
  }
  var cur = null, last = null;
  doors.forEach(function (d) {
    d.st = state(d);
    if (d.st === 'new' || d.st === 'open' || d.st === 'last') { if (!cur || d.n > cur.n) cur = d; }
  });
  doors.forEach(function (d) { if (d.st === 'last' && d !== cur) last = d; });
  var phase = today < doors[0].open ? 'pre' : (today > doors[COUNT - 1].close ? 'post' : 'live');

  /* Artikel je Türchen */
  var deals = {};
  $$('[data-spak-deal]').forEach(function (a) { deals[a.getAttribute('data-spak-deal')] = a; });
  function link(n) {
    var a = deals[n];
    if (!a || !a.dataset.url) return '';
    var u = a.dataset.url;
    return test ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'spdeal=open' : u;
  }

  /* Testhinweis */
  if (test) {
    var tb = $('[data-spak-test]');
    tb.textContent = (EN ? 'Test mode · simulated day: ' : 'Testmodus · simulierter Tag: ') + dLong(today);
    tb.hidden = false;
  }

  /* Wand */
  $$('[data-spak-door]').forEach(function (a) {
    var d = doors[parseInt(a.getAttribute('data-spak-door'), 10) - 1];
    if (!d) return;
    var sub = a.querySelector('[data-spak-sub]');
    var url = link(d.n);
    a.classList.add('is-' + (d.st === 'new' || d.st === 'open' ? 'open' : d.st));
    if (d === cur) a.classList.add('is-open');
    var txt = '';
    if (d.st === 'new') txt = EN ? 'New' : 'Neu';
    else if (d.st === 'open') txt = (EN ? 'until ' : 'bis ') + dShort(d.close);
    else if (d.st === 'last') txt = EN ? 'until 11:59 pm' : 'bis 23:59';
    else if (d.st === 'future') txt = dShort(d.open);
    else txt = EN ? 'Over' : 'Vorbei';
    if (sub) sub.textContent = txt;
    var lbl = (EN ? 'Door ' : 'Türchen ') + d.n + ', ' + dLong(d.open) + ': ';
    if ((d.st === 'new' || d.st === 'open' || d.st === 'last') && url) {
      a.href = url;
      a.setAttribute('aria-label', lbl + (EN ? 'open now' : 'jetzt offen'));
    } else {
      a.removeAttribute('href');
      a.setAttribute('role', 'img');
      a.setAttribute('aria-label', lbl + (d.st === 'future' ? (EN ? 'opens ' : 'öffnet ') + dLong(d.open) : (d.st === 'past' ? (EN ? 'over' : 'vorbei') : (EN ? 'product coming soon' : 'Artikel folgt'))));
      a.title = d.st === 'future' ? (EN ? 'Opens ' : 'Öffnet am ') + dLong(d.open) : '';
    }
  });

  /* Status */
  var st = $('[data-spak-status]');
  if (phase === 'pre') st.textContent = (EN ? 'Starts ' : 'Start am ') + dLong(doors[0].open) + (EN ? ', 0:00' : ', 0:00 Uhr');
  else if (phase === 'post') st.textContent = EN ? 'The calendar is over' : 'Der Kalender ist vorbei';
  else if (cur) st.textContent = (EN ? 'Open today · door ' : 'Heute offen · Türchen ') + cur.n + (EN ? ' of ' : ' von ') + COUNT;

  /* Deal-Karte */
  function span(ms) {
    if (ms < 0) ms = 0;
    var dd = Math.floor(ms / DAY), hh = Math.floor((ms % DAY) / HOUR), mm = Math.floor((ms % HOUR) / 6e4);
    var p = [];
    if (dd) p.push(dd + (EN ? (dd === 1 ? ' day' : ' days') : (dd === 1 ? ' Tag' : ' Tage')));
    if (hh || dd) p.push(hh + (EN ? ' hrs' : ' Std.'));
    if (!dd) p.push(mm + (EN ? ' min' : ' Min.'));
    return p.join(' ');
  }
  var show = phase === 'pre' ? doors[0] : cur;
  var card = null;
  if (show) {
    card = deals[show.n] || deals['0'];
    if (card === deals['0']) {
      card.querySelector('[data-spak-emptynr]').textContent = show.n;
    }
    card.hidden = false;
    var btn = card.querySelector('[data-spak-btn]');
    if (btn) {
      btn.href = link(show.n) || btn.href;
      if (phase === 'pre') {
        btn.classList.add('is-ghost');
        btn.querySelector('[data-spak-btntext]').textContent = EN ? 'Preview door 1' : 'Türchen 1 vorab ansehen';
      }
    }
  }
  function tick() {
    if (!card) return;
    var cd = card.querySelector('[data-spak-cdtext]');
    if (!cd) return;
    var n = nowMs();
    if (phase === 'pre') cd.textContent = (EN ? 'Opens in ' : 'Öffnet in ') + span(berlinEpoch(doors[0].open) - n);
    else cd.textContent = (EN ? '' : 'Noch ') + span(berlinEpoch(show.close + DAY) - n) + (EN ? ' left' : '');
  }
  tick();
  if (!sim) setInterval(tick, 30000);

  /* Letzte Chance */
  var ll = $('[data-spak-last]');
  if (last && link(last.n)) {
    ll.href = link(last.n);
    ll.querySelector('[data-spak-lastpill]').textContent = (EN ? 'Last chance · door ' : 'Letzte Chance · Türchen ') + last.n;
    ll.querySelector('[data-spak-lasttext]').textContent = EN ? 'Secure it until 11:59 pm →' : 'Bis 23:59 Uhr sichern →';
    ll.hidden = false;
  }
})();
